import {Link} from "react-router-dom";
import logo from "../../img/hop.png";

export default function BrandLogo() {
  return (
    <div className="flex md:absolute md:left-0 md:inset-y-0 lg:static xl:col-span-2">
      <div className="flex-shrink-0 flex items-center">
        <Link to="/dashboard">
          <img
            className="block h-8 w-auto"
            src={logo}
            alt="Hopsteiner"
            width="50"
          />
        </Link>
        <div className="font-display uppercase text-2xl pt-1  px-4">
          <Link to="/dashboard">Pflanzerportal</Link>
        </div>
      </div>
    </div>
  )
}
